import type { RefObject } from 'react'
import { getLineBounds, applyChange, insertAtSelection } from '../utils'
import {
  matchList,
  findListItemStartLine,
  buildNewListMarker,
} from '../listUtils'
import { markdownConfig } from '../../config'

export const newListItemAction = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
  increaseNumber: boolean = markdownConfig.incrementOrderedListMark,
): boolean => {
  const el = textareaRef.current
  if (!el) return false

  const s = el.selectionStart ?? 0
  const e = el.selectionEnd ?? s

  if (value[s - 1] === '\\') return false

  const before = value.slice(0, s)
  const after = value.slice(e)

  const { line: lineBefore, lineStart } = getLineBounds(before, before.length)
  const currLineMatch = matchList(lineBefore)

  const m = currLineMatch ?? findListItemStartLine(value, lineStart, lineBefore)
  if (!m) return false

  const indent = m[1] || ''
  const fullMarker = m[2] || ''
  const numStr = m[3] || ''
  const delim = m[4] || '.'

  const marker = buildNewListMarker(fullMarker, numStr, delim, increaseNumber)
  const insert = `\n${indent + marker}`

  const { next, caret } = insertAtSelection(before, insert, after)

  applyChange(textareaRef, onChange, next, caret)
  return true
}
